<template>
  <BaseModal
    :is-component-modal-active="displayModal"
    :height="'38rem'"
    :width="'22rem'"
  >
    <span slot="title">
      <h3>{{ preloadedTemplateInfo.name }}</h3>
    </span>
    <span slot="paragraph">
      <p class="my-4">
        When this Trip would
        <span class="has-text-weight-semibold">start</span>?
      </p>
      <div style="pointer-events: none">
        <BaseDatePicker
          placeholder="Start date"
          :value="preloadedTemplateInfo.start_date"
          size="medium"
          class="field"
        />
      </div>
      <BaseDatePickerByRange
        v-model="preloadedTemplateInfo.start_date"
        class="mt-2"
        inline
        placeholder="Select a date..."
        size="is-small"
      >
      </BaseDatePickerByRange>
    </span>
    <div slot="buttons" class="is-flex">
      <BaseButton
        action="secondary"
        size="medium"
        class="mr-4"
        @click="displayModal = false"
      >
        <p slot="text">Close modal</p>
      </BaseButton>
      <BaseButton
        data-action-type="ITINERARY_CUSTOMIZE"
        action="tercery"
        size="medium"
        :data-test-id="
          constants.DATA_TEST_ID_VALUES.EX_ITINERARY_CUSTOMIZE_BUTTON_CONFIRM
        "
        @click="
          displayModal = false;
          handleDuplicate(preloadedTemplateInfo);
        "
      >
        <p slot="text">Continue</p>
      </BaseButton>
    </div>
  </BaseModal>
</template>
<script>
import BaseModal from "@/components/base-ui/BaseModal.vue";
import BaseDatePicker from "@/components/base-ui/BaseDatePicker.vue";
import BaseDatePickerByRange from "@/components/base-ui/BaseDatePickerByRange.vue";
import BaseButton from "@/components/base-ui/BaseButton.vue";
import { DATA_TEST_ID_VALUES } from "@/constants/test";

export default {
  name: "PreloadDataModal",
  components: {
    BaseModal,
    BaseDatePicker,
    BaseDatePickerByRange,
    BaseButton,
  },
  props: {
    showPreloadTemplateInfoModal: {
      type: Boolean,
      default: false,
    },
    preloadedTemplateInfo: {
      type: Object,
      default: () => {},
    },
    handleDuplicate: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      constants: {
        DATA_TEST_ID_VALUES,
      },
    };
  },
  computed: {
    displayModal: {
      get() {
        return this.showPreloadTemplateInfoModal;
      },
      set(value) {
        this.$emit("update:showPreloadTemplateInfoModal", value);
      },
    },
    preloadedData: {
      get() {
        return this.preloadedTemplateInfo;
      },
      set(value) {
        this.$emit("update:preloadedTemplateInfo", value);
      },
    },
  },
};
</script>
